module.exports = __webpack_public_path__ + "img/main-bg.e453c08d.png";